import { BrushItem } from "./types";


export const BrushItems: BrushItem[] = [
  {
    name: "Basic",
    brushType: 0,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Square",
    brushType: 12,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Droplet",
    brushType: 1.9,
    description: "",
    gif: "",
    minSize: 5,
  },
  {
    name: "Noisey Droplet",
    brushType: 1.11,
    description: "",
    gif: "",
    minSize: 4,
  },
  {
    name: "Asteroid",
    brushType: 1.12,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Helix",
    brushType: 1.1,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Bird",
    brushType: 1.2,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Blink",
    brushType: 1.3,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Dust",
    brushType: 1.4,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Explode",
    brushType: 1.5,
    description: "",
    gif: "",
    minSize: 3,
  },
  {
    name: "Dancing Cube",
    brushType: 1.7,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Noisey Blob",
    brushType: 1.6,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Wireframe",
    brushType: 1.8,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Diamond Square",
    brushType: 1,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Stars",
    brushType: 2,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Ripple",
    brushType: 3,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Voroni",
    brushType: 4,
    description: "",
    gif: "",
    minSize: 0,
  },

  {
    name: "Hair",
    brushType: 6,
    description: "",
    gif: "",
    minSize: 0,
  },

  {
    name: "Leaf",
    brushType: 7,
    description: "",
    gif: "",
    minSize: 0,
  },

  {
    name: "Diamond",
    brushType: 8,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Splatter",
    brushType: 9,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Brushy",
    brushType: 10,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Flower Power",
    brushType: 1.13,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "NeoGeo",
    brushType: 1.14,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Grid",
    brushType: 11,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Lava Lamp",
    brushType: 1.15,
    description: "",
    gif: "",
    minSize: 0,
  },
  {
    name: "Extra Lava",
    brushType: 1.16,
    description: "",
    gif: "",
    minSize: 0,
  },
  { name: "Donut", brushType: 1.17, description: "", gif: "",
    minSize: 0,
  },
  { name: "Donuts", brushType: 1.18, description: "", gif: "",
    minSize: 0,},
];

const _brushMinSizes: Record<number, number> = {};
const _brushNames: Record<number, String> = {};
BrushItems.forEach( (item:BrushItem) => {
  _brushMinSizes[item.brushType] = item.minSize;
  _brushNames[item.brushType] = item.name;
})


export const brushNames = _brushNames;
export const brushMinSizes = _brushMinSizes;